var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcShcool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.245 8.312v-.578c0-.065-.076-.12-.167-.12h-1.91c-.092 0-.166.055-.166.12v.578c0 .066.074.12.166.12h.095l-.117 5.549h-.123v.303h2.174v-.303H5.1l-.117-5.55h.096c.09-.001.167-.055.167-.12zM11.22 8.312v-.578c0-.065-.075-.12-.165-.12h-1.91c-.092 0-.166.055-.166.12v.578c0 .066.074.12.166.12h.095l-.117 5.549h-.124v.303h2.175v-.303h-.098l-.118-5.55h.097c.09-.001.165-.055.165-.12zM17.198 8.312v-.578c0-.065-.074-.12-.165-.12H15.13c-.092 0-.166.055-.166.12v.578c0 .066.074.12.166.12h.095l-.117 5.549h-.126v.303h2.174v-.303h-.095l-.117-5.55h.096c.085-.001.16-.055.16-.12z",
    fill: "#4CA1AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.741 14.281H2.426v.585H17.74v-.585zM17.657 6.656H2.342v.585h15.315v-.585zM18.252 15.071H1.793v.585h16.459v-.585zM18.823 15.886H1.176v.585h17.647v-.585zM16.101 5.625l-4.79-1.894a3.845 3.845 0 0 0-2.456 0L4.062 5.625H1.793v.646h16.456v-.646H16.1zm-6-.158a.606.606 0 0 1-.33-.098.581.581 0 0 1-.219-.259.563.563 0 0 1 .13-.63.6.6 0 0 1 .646-.125.591.591 0 0 1 .267.213.566.566 0 0 1-.074.73.603.603 0 0 1-.42.169z",
    fill: "#4CA1AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShcool);
export default __webpack_public_path__ + "static/media/ic_shcool.31a758d81dd83230e062fc9f817e20c2.svg";
export { ForwardRef as ReactComponent };